export default {
  country_locale: 'pt-PT',
  wia_title: 'Prevenção de Intervenção na Web',
  wia_need_help: 'Eu necessito de ajuda com ',
  wia_model_name: 'O modelo é',
  wia_back: '<alterar',
  wia_confirm: 'Confirmar',
  wia_issue_title: 'Qual é o seu problema?',
  wia_issue_concern: 'O meu problema consiste',
  wia_issue_specific: 'Especifique seu problema',
  wia_possible_solution: 'Soluções possíveis',
  wia_solved_issue: 'Resolveu o problema?',
  wia_closed: 'Fechar X',
  wia_feedback_ok: 'Sim!',
  wia_find_another_solution: 'Encontrar outra solução',
  wia_feedback_title: 'Ficamos satisfeitos pelo problema ter ficado resolvido!',
  wia_feedback_text1: 'Visite a nossa loja com ofertas especiais dedicadas a si',
  wia_feedback_text2: 'Saiba mais sobre as nossas novas tecnologias inteligentes!',
  wia_smile_up_popup_text1: 'Conheça nossos planos de proteção',
  wia_smile_down_popup_title: 'Nos desculpe',
  wia_smile_down_popup_text1: 'Vá para a segunda etapa',
  wia_smile_down_popup_or_text: 'or',
  wia_smile_down_popup_text2: 'Zarezerwuj naprawę',
  wia_need_more_help: 'Precisa de mais ajuda?',
  wia_optional_label: '(opcional)',
  wia_no_solution: 'Infelizmente não há soluções de autoatendimento diretas para o seu problema. Por favor, clique aqui para obter suporte.',
  wia_all_solution: 'Todas as soluções',
  wia_all_categories: 'Todas as categorias',
  wia_seo_l1_issue: 'Todos os problemas',
  wia_seo_wp_country_name: 'Portugal',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: 'PT',
  wia_seo_id_country_name: 'PT',
  wia_seo_wp_meta_title: 'Problemas e soluções',
  wia_seo_bk_meta_title: 'Problemas e soluções',
  wia_seo_hp_meta_title: 'Problemas e soluções',
  wia_seo_id_meta_title: 'Problemas e soluções',
  wia_seo_wp_meta_description: 'resolva os problemas relacionados com os seus eletrodomésticos com apenas alguns cliques com a assistência técnica online da Whirlpool Portugal',
  wia_seo_bk_meta_description: 'resolva os problemas relacionados com os seus eletrodomésticos com apenas alguns cliques com a assistência técnica online da Bauknecht Portugal',
  wia_seo_hp_meta_description: 'resolva os problemas relacionados com os seus eletrodomésticos com apenas alguns cliques com a assistência técnica online da Hotpoint Portugal',
  wia_seo_id_meta_description: 'resolva os problemas relacionados com os seus eletrodomésticos com apenas alguns cliques com a assistência técnica online da Indesit Portugal',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
